export function filterItemsByLetterAndType(itemsByLetter, query, typeFilter = "all") {
  const normalized = query.toLowerCase().trim()
  const filtered = {}

  Object.entries(itemsByLetter).forEach(([letter, items]) => {
    const visible = items.filter((item) => {
      const matchesSearch = !normalized || item.searchName.includes(normalized)
      const matchesType = typeFilter === "all" || item.type === typeFilter
      return matchesSearch && matchesType
    })

    if (visible.length > 0) {
      filtered[letter] = visible
    }
  })

  return filtered
}
